import {
	CLOSE_TEAM_SPRINT_ASSOCIATION_MODEL,
	OPEN_TEAM_SPRINT_ASSOCIATION_MODEL,
} from '../../../actions/sprints/sprint-association-modal/index.tsx';
import type { Action } from '../../../types.tsx';
import type { SprintAssociationModalState } from './types.tsx';

const defaultState = { isOpen: false } as const;

export const sprintAssociationModalReducer = (
	state: SprintAssociationModalState = defaultState,
	action: Action,
): SprintAssociationModalState => {
	if (action.type === OPEN_TEAM_SPRINT_ASSOCIATION_MODEL) {
		return {
			isOpen: true,
			...action.payload,
		};
	}
	if (action.type === CLOSE_TEAM_SPRINT_ASSOCIATION_MODEL) {
		return { isOpen: false };
	}

	return state;
};
